import { HttpResponse } from '@angular/common/http';
import { DateTimeHelper } from './../utils/date-time-helper';
export class HttpResponseInterceptor {

    static intercept<T>(evt: HttpResponse<T>) {
        DateTimeHelper.recursivelyConvertUTCDateTimeToOrgTime(evt.body, null, null);
    }

}
